var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarcierLogoWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path Copy 26",
    d: "M19.4988 0L18.9108 0.873423C14.0587 7.93787 7.93545 14.0611 0.87101 18.9133L0 19.5012L0.87101 20.0892C7.93545 24.9413 14.0587 31.0645 18.9108 38.129L19.4988 39L20.0867 38.129C24.9389 31.0645 31.0621 24.9413 38.1266 20.0892L39 19.5012L38.1266 18.9133C31.0621 14.0611 24.9389 7.93787 20.0867 0.873423L19.4988 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarcierLogoWhite);
export default __webpack_public_path__ + "static/media/starcier-logo-white.38840b875cbdfa09945a08a7420b1c58.svg";
export { ForwardRef as ReactComponent };